exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrm-targeted-theme {\n  max-width: 700px;\n  margin: 0 auto;\n  padding: 10px; }\n  .scrm-targeted-theme a {\n    outline: none; }\n  .scrm-targeted-theme img {\n    margin: 0 auto;\n    max-width: 100%;\n    max-height: 100%; }\n  .scrm-targeted-theme .slick-dotted.slick-slider {\n    margin-bottom: 0px; }\n  .scrm-targeted-theme .slick-dots {\n    bottom: 10px; }\n    .scrm-targeted-theme .slick-dots li {\n      margin: 0; }\n      .scrm-targeted-theme .slick-dots li button:before {\n        font-size: 15px;\n        color: white;\n        opacity: 1; }\n      .scrm-targeted-theme .slick-dots li.slick-active button:before {\n        color: #e11c21;\n        opacity: 1; }\n  .scrm-targeted-theme .slick-track {\n    margin: 0 auto; }\n  .scrm-targeted-theme .slick-slide {\n    outline: none;\n    cursor: pointer;\n    padding: 5px 5px; }\n  .scrm-targeted-theme .slick-slide:not(.slick-current) {\n    opacity: 0.4; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/slick-targeted-theme.scss
// module id = 29
// module chunks = 0